import { Controller } from "@hotwired/stimulus";
import { patch } from '@rails/request.js';

export default class extends Controller {
  static targets = ['valuerFee', 'margin', 'lenderFee', 'availableFrom', 'eventField'];
  static values = { quoteId: String };

  connect() {
    this.debounceTimeout = null;
    this.setupFormatting();
    this.boundReenableSubmitButtons = this.reenableSubmitButtons.bind(this);
    this.element.addEventListener('turbo:submit-end', this.boundReenableSubmitButtons);
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.boundReenableSubmitButtons);
  }

  reenableSubmitButtons() {
    this.element.querySelectorAll('button[type="submit"][disabled]').forEach(button => {
      button.disabled = false;
    });
  }

  setupFormatting() {
    [this.valuerFeeTarget, this.marginTarget, this.lenderFeeTarget].forEach(target => {
      requestAnimationFrame(() => this.formatField(target));
      target.addEventListener('blur', () => this.formatField(target));
    });
  }

  formatField(target) {
    const value = Number(target.value.replace(/,/g, ''));
    if (!isNaN(value) && value !== 0 && target.value !== '') {
      target.value = value.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      target.previousElementSibling.value = value;
    }
  }

  updateMargin() {
    const marginValue = this.lenderFeeValue() - this.valuerFeeValue();
    this.marginTarget.value = marginValue.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.marginTarget.previousElementSibling.value = marginValue;
  }

  updateLenderFee() {
    const lenderFeeValue = this.valuerFeeValue() + this.marginValue();
    this.lenderFeeTarget.value = lenderFeeValue.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.lenderFeeTarget.previousElementSibling.value = lenderFeeValue;
  }

  valuerFeeValue() {
    return Number(this.valuerFeeTarget.value.replace(/,/g, ''));
  }

  marginValue() {
    return Number(this.marginTarget.value.replace(/,/g, ''));
  }

  lenderFeeValue() {
    return Number(this.lenderFeeTarget.value.replace(/,/g, ''));
  }

  setClarificationEvent(event) {
    event.preventDefault();
    this.availableFromTarget.removeAttribute('data-required');
    this.eventFieldTarget.value = "move_to_draft";
    this.element.removeAttribute("data-turbo-stream");
    this.element.requestSubmit();
  }

  setCompleteEvent(event) {
    event.preventDefault();
    this.eventFieldTarget.value = "receive_quote";
    this.element.setAttribute("data-turbo-stream", "");
    this.element.requestSubmit();
  }

  debouncedUpdateLabels() {
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      this.updateLabels();
    }, 750);
  }

  async updateLabels() {
    // Use document.querySelectorAll because checkboxes are in a portal (outside form element)
    // but they have form="form_id" attribute that associates them with this form
    const formId = this.element.id;
    const labelElements = document.querySelectorAll(`input[name="quote[label_list][]"][form="${formId}"]:checked`);
    const labelList = Array.from(labelElements).map(el => el.value);
    const labelsWrapper = document.getElementById(`labels_quote_${this.quoteIdValue}`);

    await patch(`/quotes/${this.quoteIdValue}/labels`, {
      body: JSON.stringify({
        label_list: labelList,
        pill_size: labelsWrapper?.dataset.pillSize,
      }),
      contentType: 'application/json',
      responseKind: 'turbo-stream',
    });
  }
}
